import React from "react";
import makemedia from "../../assets/copyright_makemedia.png";
import Fancybox from "../Fancybox/Fancybox";

const PageCopyright = (props) => {
  return (
    <div className="page_copyright">
      <div className="container">
        <div className="row justify-content-between align-items-center">
          <div className="col powered">
            Copyright © Italimpianti S.R.L. / P.I. – C.F. 03981190162 – REA MI
            2523183 - Capitale Sociale interamente versato €. 500.000,00 -
            <Fancybox>
              <a
                href="/privacy-policy.html"
                data-fancybox
                data-type="iframe"
                data-preload="false"
                data-width="640"
                data-height="480"
              >
                Privacy Policy
              </a>
            </Fancybox>
          </div>
          <div className="col copyright-img">
            <div className="">
              <a href="https://www.makemedia.it/" target="_blank">
                <img src={makemedia} style={{ width: "120px" }} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageCopyright;
